<script>
import UserAvatar20 from "@carbon/icons-vue/es/user--avatar/20";
import { mapGetters, mapActions, mapMutations } from "vuex";
import MenuItem from "./MenuItem.vue";
import { LOGOUT } from "@/store/actions.type";
import {
  DELETE_USER,
  GET_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES,
} from "@/store/actions.type";
import { UserImagesService } from "@/common/api.service";

export default {
  name: "MyHeader",
  components: { MenuItem, UserAvatar20 },
  data() {
    return {
      isPictureLoading: true,
      profilePicture: null,
      profileEmail: null,
      profileName: "User",

      // Perms required to display the section
      RManagementPerms: ["URF", "TSCF"],
      ManagementPerms: ["OSCF", "OSF", "PROF", "URF"],
      SettingsPerms: ["AA", "RMC", "AURM", "ABF"],

      // Individual route with access perm requirement
      management: [
        {
          name: "Candidates",
          path: "/engagements/candidates",
          permNeeded: ["OSCF"],
          imgSource: "candidatesShortcutLogo.svg",
        },
        {
          name: "Open Seats",
          path: "/engagements/open-seats",
          permNeeded: ["OSF"],
          imgSource: "openSeatsShortcutLogo.svg",
        },
        {
          name: "Projects",
          path: "/engagements/projects",
          permNeeded: ["PROF"],
          imgSource: "projectSearchShortcutLogo.svg",
        },
        {
          name: "Users",
          path: "/engagements/users",
          permNeeded: ["URF"],
          imgSource: "usersLogo.svg",
        },
      ],
      resourceManagement: [
        // TODO redo boarding
        // {
        //   name: "Boarding",
        //   path: "/boarding",
        //   permNeeded: ["AA"],
        //   imgSource: "onboarding.svg",
        // },
        {
          name: "Resources",
          path: "/resourcing/resources",
          permNeeded: ["URF"],
          imgSource: "resourcesShortcutLogo.svg",
        },
        {
          name: "TSC",
          path: "/resourcing/tsc",
          permNeeded: ["TSCF"],
          imgSource: "TSCShortcutLogo.svg",
        },
      ],
      settings: [
        {
          name: "Application Configuration",
          path: "/admin/settings/application-configuration",
          permNeeded: ["AA"],
          imgSource: "appConfig.svg",
        },
        {
          name: "Resource Management",
          path: "/admin/settings/resource-management",
          permNeeded: ["RMC"],
          imgSource: "rm.svg",
        },
        {
          name: "User & Role Management",
          path: "/admin/settings/role-management",
          permNeeded: ["AURM"],
          imgSource: "urm.svg",
        },
        {
          name: "Support",
          path: "/admin/settings/support",
          permNeeded: ["ABF"],
          imgSource: "feedbackAndBugs.svg",
        },
      ],
      insights: [
        {
          name: "Insights",
          path: "/insights",
          permNeeded: ["ANL"],
          imgSource: "insightsShortcutLogo.svg",
        },
        // {
        //   name: "Reporting",
        //   path: "/reporting",
        //   permNeeded: ["ANL"],
        //   imgSource: "projectSnapshotShortcutLogo.svg",
        // },
      ],
      showModal: false,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      user: "currentUser",
      checkPerms: "userHasPerm",
      userPreferences: "userPreferences",
      notifications: "notification",
      userRoles: "userRoles",
    }),
    names: function () {
      if (this.profileName) {
        return this.profileName.split(" ");
      } else {
        return ["N/A"];
      }
    },
    theme() {
      return this.userPreferences.darkmode ? "g100" : "white";
    },
  },
  watch: {
    async user() {
      await this.getUserIconData();
    },
    "userPreferences.darkmode": {
      handler(value) {
        if (value != localStorage.getItem("darkmode")) {
          localStorage.setItem("darkmode", value);
        }
        document.body.setAttribute("data-carbon-theme", this.theme);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      logoutUser: LOGOUT,
      deleteUser: DELETE_USER,
      updateUserPreferences: UPDATE_USER_PREFERENCES,
      getUserPreferences: GET_USER_PREFERENCES,
    }),
    hideModal() {
      this.showModal = false;
    },
    openDelete() {
      this.showModal = true;
    },
    logout() {
      this.logoutUser();
      this.$router.push("/login");
    },
    routerPush(route) {
      this.$router.push(route);
    },
    async handleDelete() {
      try {
        this.hideModal();
        await this.deleteUser();
        await this.logoutUser();
        this.$router.push("/login");
        this.notifications.push({
          title: "Account deleted successfully",
          kind: "success",
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    async getUserIconData() {
      //Gets both profile image and profile full name.  This is then used in the user icon on the navbar
      if (this.user?.penpic_completed) {
        try {
          const { data } = await UserImagesService.get(this.user.serial_number);
          this.profileName = this.user.full_name;
          this.profilePicture = data;
          this.profileEmail = this.user.email;
        } catch (error) {
          if (
            error.message ==
            "Cannot read properties of undefined (reading 'data')"
          ) {
            this.$router.push("/");
            this.logoutUser();
          }
          throw new Error(error);
        }
      }
    },
    fontSizeCalc(namelength) {
      const maxFont = 90;
      const minFont = 55;
      const maxNameLength = 50;
      const minNameLength = 30;
      let ans =
        (namelength * minFont -
          minNameLength * minFont +
          maxNameLength * maxFont -
          namelength * maxFont) /
        (maxNameLength - minNameLength);
      return ans;
    },

    async getNames(name) {
      try {
        if (name[0].length >= 21) {
          const resize = document.querySelector(".resizeNavFirst");
          resize.style.fontSize = this.fontSizeCalc(name[0].length) + "%";
        }
        if (name.length != 1 && name[name.length - 1].length >= 21) {
          const resize = document.querySelector(".resizeNavLast");
          resize.style.fontSize =
            this.fontSizeCalc(name[name.length - 1].length) + "%";
        }
        return false;
      } catch (error) {
        throw new Error(error);
      }
    },
    async toggleTheme() {
      localStorage.setItem("darkmode", !this.userPreferences.darkmode);
      await this.updateUserPreferences({
        data: { darkmode: !this.userPreferences.darkmode },
        id: this.user.id,
      });

      document.body.setAttribute("data-carbon-theme", this.theme);
    },
  },
};
</script>

<template>
  <cv-header aria-label="Carbon header">
    <cv-modal
      ref="modalview"
      kind="danger"
      :visible="showModal"
      @modal-hidden="hideModal"
      @primary-click="handleDelete"
    >
      <template #title>
        <h3>Delete Account</h3>
      </template>

      <template #content>
        <div style="font-size: 16px">
          <p>Are you sure you want to delete your SkillsMatch account?</p>
          <br />
          <p>
            This action is irreversible and will permanently delete all PenPic
            data obtained from W3 and YourLearning.
          </p>
          <br />
          <p>
            By confirming this action, you are revoking your consent for the use
            of your data.
          </p>
          <br />
          <p>
            For more information about how we handle your data, please refer to
            <a
              href="https://w3.ibm.com/w3publisher/w3-privacy-notice/"
              target="_blank"
            >
              IBM's policy.
            </a>
          </p>
        </div>
      </template>
      <template #secondary-button>Cancel</template>
      <template #primary-button>Delete</template>
    </cv-modal>
    <cv-header-menu-button aria-label="Header menu" aria-controls="side-nav" />
    <cv-skip-to-content href="#main-content">
      Skip to content
    </cv-skip-to-content>
    <cv-header-name to="/" prefix="IBM">
      <pre></pre>
      SkillsMatch
    </cv-header-name>
    <cv-header-nav aria-label="Carbon nav">
      <MenuItem
        v-if="!isAuthenticated"
        name="Login"
        path="/login"
        type="header"
      />
      <MenuItem
        v-if="!isAuthenticated"
        name="Feedback"
        path="/feedback"
        type="header"
      />
    </cv-header-nav>
    <template v-if="isAuthenticated" #left-panels>
      <cv-side-nav id="side-nav" class="sidebar" rail>
        <cv-side-nav-items>
          <MenuItem
            name="Your Penpic"
            path="/penpic"
            type="link"
            :img-source="'yourPenPicShortcutLogo.svg'"
            :perm-needed="['CG']"
          />
          <!-- TODO redo boarding -->
          <!-- <MenuItem
            name="Tasks"
            path="/tasks"
            type="link"
            :imgSource="'yourTasksShortcutLogo.svg'"
            /> -->
          <div v-if="checkPerms(['UPPF'])">
            <hr />
            <MenuItem
              name="PenPic Search"
              path="/search"
              type="link"
              :img-source="'penpicSearchShortcutLogo.svg'"
            />
          </div>

          <div v-if="checkPerms(RManagementPerms)">
            <hr />
            <div v-for="item in resourceManagement">
              <MenuItem
                v-if="checkPerms(item.permNeeded)"
                :key="item.name"
                :name="item.name"
                :path="item.path"
                :perm-needed="item.permNeeded"
                :img-source="item.imgSource"
                type="link"
              />
            </div>
            <hr />
          </div>
          <div v-if="checkPerms(ManagementPerms)">
            <div v-for="item in management">
              <MenuItem
                v-if="checkPerms(item.permNeeded)"
                :key="item.name"
                :name="item.name"
                :path="item.path"
                :perm-needed="item.permNeeded"
                :img-source="item.imgSource"
                type="link"
              />
            </div>
          </div>

          <div v-if="checkPerms(['ANL'])">
            <hr />
            <MenuItem
              v-for="item in insights"
              :key="item.name"
              :name="item.name"
              :path="item.path"
              :perm-needed="item.permNeeded"
              :img-source="item.imgSource"
              type="link"
            />
          </div>
          <hr />
          <MenuItem
            name="Support"
            path="/feedback"
            type="link"
            :img-source="'feedback.svg'"
          />
          <div v-if="checkPerms(SettingsPerms)">
            <hr />
            <MenuItem
              v-for="item in settings"
              :key="item.name"
              :name="item.name"
              :path="item.path"
              :perm-needed="item.permNeeded"
              :must-have-penpic="item.mustHavePenpic"
              :role-override="item.roleOverride"
              :show-when-not-logged-in="item.showWhenNotLoggedIn"
              :img-source="item.imgSource"
              :disabled="item.disabled"
              type="link"
            />
          </div>
        </cv-side-nav-items>
      </cv-side-nav>
    </template>
    <template #header-global>
      <cv-header-global-action
        v-if="isAuthenticated"
        :label="user?.full_name ? user.full_name : ''"
        aria-controls="user-panel"
        tip-position="bottom"
        tip-alignment="end"
      >
        <UserAvatar20
          v-if="
            isAuthenticated && (!profilePicture || profilePicture == 'data')
          "
        />
        <img
          v-else
          class="profile-picture-nav"
          width="18"
          height="18"
          :src="profilePicture"
        />
      </cv-header-global-action>
    </template>
    <template #right-panels>
      <cv-header-panel v-if="isAuthenticated" id="user-panel">
        <div style="font-size: 0.875rem; padding: 1rem">
          <h4
            class="name-font-size resizeNavFirst"
            :class="getNames(names) ? 'name-font-size' : 'resizeNavFirst'"
          >
            {{ user?.full_name ? user.full_name : "" }}
          </h4>
          <p v-if="isAuthenticated" class="candidate-name">
            {{ userRoles }}
            {{ profileEmail }}
          </p>
        </div>
        <cv-toggle
          style="margin-left: 1rem"
          value="themeToggle"
          label="Dark Mode"
          :small="true"
          :checked="userPreferences.darkmode"
          @change="toggleTheme"
        >
        </cv-toggle>
        <br />

        <cv-switcher>
          <hr />
          <cv-switcher-item v-if="isAuthenticated">
            <cv-switcher-item-link
              href="https://ibm.enterprise.slack.com/archives/C08G8KDH1TQ"
              target="_blank"
            >
              Community Support Channel
            </cv-switcher-item-link>
          </cv-switcher-item>
          <cv-switcher-item v-if="isAuthenticated">
            <cv-switcher-item-link
              href="https://w3.ibm.com/w3publisher/w3-privacy-notice/"
              target="_blank"
            >
              Privacy Policy
            </cv-switcher-item-link>
          </cv-switcher-item>
          <hr />
          <cv-switcher-item>
            <cv-switcher-item-link @click="logout">
              Logout
            </cv-switcher-item-link>
          </cv-switcher-item>
          <cv-switcher-item v-if="isAuthenticated">
            <cv-switcher-item-link @click="openDelete">
              Delete Account
            </cv-switcher-item-link>
          </cv-switcher-item>
        </cv-switcher>
      </cv-header-panel>
    </template>
  </cv-header>
</template>

<style lang="scss">
nav hr {
  width: calc(100% - 1.75rem);
  border: 1px solid #393939;
  border-bottom: 0;
  margin: 0.75rem 0.8125rem;
}

a.bx--side-nav__link[aria-current="page"],
a.bx--side-nav__link:hover {
  background-color: #353535 !important;
}

a.bx--side-nav__link[aria-current="page"] .bx--side-nav__link-text,
.bx--side-nav__item:not(.bx--side-nav__item--active)
  > .bx--side-nav__link:hover
  > span {
  color: white !important;
}

.bx--toggle-input__label,
a.bx--side-nav__link > .bx--side-nav__link-text {
  color: #c6c6c6 !important;
}

.bx--side-nav {
  background-color: #161616 !important;
  border-right: 1px solid #393939;
}

.profile-picture-nav {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  outline: white solid 1px;
}
</style>
